export default __webpack_public_path__ + "static/media/kzfSchonbezuge.705f85bc.jpg";